import { capitalCase } from 'change-case';
import get from 'lodash/get.js';

import Filter from '@/components/modal-select/filters/Filter.js';

export default class DropdownFilter extends Filter {
    constructor(field, label) {
        super(field, label);

        this.type = 'dropdown';
        this.options = [];
        this.autoApply = true;
        this.value = null;

        this.handler = async ({ filterEvent }) => {
            const value = filterEvent.getAttribute('value');

            if (!value) {
                this.queryBuilder.removeFilter(field);
                this.value = null;
            } else {
                this.queryBuilder.filter(field, value);
                this.value = value;
            }
        };
    }

    applyToModel(query, value, field) {}

    isActiveChoice(option) {
        const appliedFilter = this.queryBuilder.getFilter(this.field);

        return get(appliedFilter, 'value') === option.value;
    }

    addOption(value, label) {
        if (!label) {
            label = capitalCase(value);
        }

        this.options.push({ value, label });

        return this;
    }

    addOptions(options) {
        options.forEach(option => {
            this.addOption(option.value, option.label);
        });
        return this;
    }

    clearFilter() {
        this.queryBuilder.removeFilter(this.field);

        this.value = null;
    }

    get is_applied() {
        return this.queryBuilder.hasFilter(this.field);
    }
}
